<template>
  <div class="resetPassword">
    <welcome-image/>
    <section class="resetPassword__right">
      <div v-if="!sent" class="resetPassword__form">
        <div class="resetPassword__line">
          <label class="resetPassword__textLabel">Почта</label>
          <form-input v-model="email" type="text" autocomplete="false"/>
        </div>
        <div class="resetPassword__line">
          <div class="resetPassword__buttons">
            <ActionButton
                :disabled="!email || loading"
                style="width: 180px"
                icon-type="arrow"
                @button-click="submitHandler"
            >
              <template #caption>Восстановить</template>
            </ActionButton>
          </div>
          <div v-if="error" class="resetPassword__error">{{ error }}</div>
        </div>
        <div class="resetPassword__line">
          <span class="resetPassword__link-row">
            <router-link class="resetPassword__link" :to="{name: 'SignInView'}">Войти</router-link>
          </span>
        </div>
      </div>

      <finish-page v-else button-caption="Войти" :exit-route="{name: 'SignInView'}">
        <template #mainText>
          <span class="resetPassword__finishHead">Письмо отправлено</span>
        </template>
        <template #infoText>
          Если аккаунт с таким адресом существует, инструкции по восстановлению пароля отправлены на&nbsp;<strong>{{ email }}</strong>
        </template>
      </finish-page>
    </section>
  </div>
</template>

<script>
import {ref} from "vue";
import FormInput from "@/components/ui/FormInput.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import WelcomeImage from "@/components/shared/WelcomeImage.vue";
import FinishPage from "@/components/shared/FinishPage.vue";
import http from "@/tools/http-client";
import environment from "@/environment";

export default {
  name: "ResetPasswordView",
  components: {FinishPage, WelcomeImage, ActionButton, FormInput},
  setup() {
    const email = ref('')
    const loading = ref(false)
    const error = ref('')
    const sent = ref(false)

    async function submitHandler() {
      if (loading.value) return;
      error.value = ''
      loading.value = true
      try {
        const resp = await http.post(environment.appConfig.baseApiUrl + 'auth/reset', {
          email: email.value,
        })
        if (resp.data?.status !== 'success') {
          error.value = resp.data?.message || 'Ошибка при отправке запроса'
          return
        }
        sent.value = true
      } catch (e) {
        error.value = e?.response?.data?.message || 'Ошибка при отправке запроса'
      } finally {
        loading.value = false
      }
    }

    return {email, loading, error, sent, submitHandler}
  }
}
</script>

<style scoped lang="scss">
.resetPassword {
  display: flex;
  padding: 60px 0;
  gap: 22px;
  align-items: stretch;
  @include respond-to('md') { flex-direction: column; padding: 32px 0; }

  &__right {
    flex: 1 1 0;
    min-width: 0;
    border-radius: 20px;
    background: var(--cd-card-bg);
    padding: 34px;

    @include respond-to('sm') { padding: 20px; }
  }

  &__form {
    text-align: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    font-family: var(--cd-default-font);
  }

  &__textLabel {
    padding: 10px 10px;
    display: block;
  }

  &__line {
    padding-bottom: 24px;
  }

  &__buttons {
    display: flex;
  }

  &__error {
    margin-top: 12px;
    color: var(--cd-danger);
    font-size: 13px;
  }

  &__link-row {
    color: var(--cd-text);
  }

  &__link {
    color: var(--cd-link-color);
    text-decoration: none;
  }

  &__finishHead {
    font-weight: 500;
    font-size: clamp(24px, 4vw, 36px);
    font-family: var(--cd-bold-font);
  }
}
</style>
